import { Box, Grid, Typography } from '@mui/material';
import IconsColor from '../../../../../../utility/iconsColor';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import globalStyles from "../../../../../../../assets/styles/global.module.scss";
import styles from '../../../../../../../assets/styles/componentStyles/channels/global/whatsapp/templates/templatePreviews/templateHeaderPreview.module.scss'
import whatsappPreviewStyles from '../../../../../../../assets/styles/componentStyles/templateLibraryStyles/whatsappTemplatePreview.module.scss'
import defaultWATemplateImg from "../../../../../../../assets/images/messageFormats/defaultWATemplateImage.png";
import { createWhatsappTemplateHeaderVariable, WA_template_header_variable_data } from '../../../../../../../models/axiosModel';

type LocationHeaderVariable = createWhatsappTemplateHeaderVariable | WA_template_header_variable_data;

interface templateHeaderPreview {
    headerType: string,
    url: string,
    headerText: string,
    headerVaraibleData: LocationHeaderVariable[],
    isCarouselTemplate?: boolean,
}
function TemplateHeaderPreview(props: templateHeaderPreview) {

    function cleanFilename(filename: string | undefined) {
        // Remove the numeric suffix before .pdf using regex
        const nameWithoutSuffix = filename?.replace(/_\d+(?=\.pdf)/, '');
        // Replace underscores with spaces
        const cleanedName = nameWithoutSuffix?.replace(/_/g, ' ');
        return cleanedName;
    }
    const { headerType, url, headerText, isCarouselTemplate } = props

    const getLocationFieldValue = (field?: LocationHeaderVariable) => {
        if (!field) return '';
        if ('whatsapp_template_dynamic_variable_sample_value' in field) {
            return field.whatsapp_template_dynamic_variable_sample_value ?? '';
        }
        if ('variable_value' in field) {
            return field.variable_value ?? '';
        }
        return '';
    }

    const locationHeaderFields = () => {
        return props?.headerVaraibleData?.filter((variable) => ['{{name}}', '{{address}}']?.includes(variable?.whatsapp_template_dynamic_variable_key?.toLowerCase())) ?? [];
    }

    const findLocationHeaderField = (headerFields: LocationHeaderVariable[], variableKey: string) => {
        return headerFields?.find((field) => field?.whatsapp_template_dynamic_variable_key?.toLowerCase() === variableKey?.toLowerCase());
    }

    const onClickOfLocationHeader = () => {
        if(locationHeaderFields()?.length > 0){
            const latitude = getLocationFieldValue(findLocationHeaderField(props?.headerVaraibleData, '{{latitude}}'));
            const longitude = getLocationFieldValue(findLocationHeaderField(props?.headerVaraibleData, '{{longitude}}'));
            const name = getLocationFieldValue(findLocationHeaderField(props?.headerVaraibleData, '{{name}}'));
            const address = getLocationFieldValue(findLocationHeaderField(props?.headerVaraibleData, '{{address}}'));

            if(latitude && longitude && latitude !== '{{latitude}}' && longitude !== '{{longitude}}'){
                const queryParts = [latitude, longitude];
                if (name && name !== '{{name}}') {
                    queryParts.push(name);
                }
                if (address && address !== '{{address}}') {
                    queryParts.push(address);
                }
                window.open(`https://www.google.com/maps/search/?api=1&query=${queryParts.join(',')}`, "_blank");
            }
        }
        return;
    }

    const renderHeaderMediaComponent = () => {
        const header = headerType?.toLowerCase() || "";
        switch (header) {
            case "image":
                return <>
                    <Grid item className={`${styles.hiddenOverflowStyle} ${globalStyles.fullwidth} ${isCarouselTemplate && styles.hiddenOverflowStyleCarouselTemplte}`}>
                        <img alt="Image" src={url || defaultWATemplateImg} className={`${styles.templatePreviewHeaderImage} ${isCarouselTemplate && styles.templatePreviewHeaderImageForCarouseltemplate}`} />
                    </Grid>
                </>;
            case "video":
                return <>
                    <Grid item className={`${styles.hiddenOverflowStyle} ${globalStyles.fullwidth}`}>
                        <video key={url} style={{ width: "100%", maxHeight: "200px" }} controls className='video-tag'>
                            <source src={url || ""} type="video/mp4" />
                        </video>
                    </Grid>
                </>;
            case "text":
                return <>
                    <Grid item className={`${styles.templatePrviewHeaderItem} ${globalStyles.fullwidth}`} dir="auto">
                        <pre
                            className={styles.preTextStyle}
                            dangerouslySetInnerHTML={{ __html: headerText }}
                        />
                    </Grid>
                </>;
            case "document":
                return <>
                    <Grid item>
                        <Grid container className={`${globalStyles.displayFlexStyle} ${globalStyles.flexColumn} ${globalStyles.gapOne} ${styles.documentPreviewContainer} ${globalStyles.justifyCenter} ${globalStyles.alignItemCenter}`}>
                            <Grid item>
                                <IconsColor iconName="documentFile" fillColor="#000" />
                            </Grid>
                            <Grid item>
                                <Typography className={styles.documentPreviewFileName}>{cleanFilename(url?.split('/').pop())}</Typography>
                            </Grid>
                            <Grid item>
                                <OpenInNewIcon className={styles.openDocumentIcon} onClick={() => window.open(url, "_blank")} />
                            </Grid>
                        </Grid>
                    </Grid>
                </>;
            case "location":
                return <>
                    <Box className={`${whatsappPreviewStyles.whatsappPreview__locationHeader} ${globalStyles.clickable}`} onClick={() => onClickOfLocationHeader()}>
                        <Box className={whatsappPreviewStyles.whatsappPreview__locationHeaderMap}>
                            <LocationOnIcon className={whatsappPreviewStyles.whatsappPreview__locationHeaderMapIcon} />
                        </Box>
                        {locationHeaderFields()?.length > 0 && 
                            <Box className={whatsappPreviewStyles.whatsappPreview__locationHeaderFields}>
                                {findLocationHeaderField(locationHeaderFields(), '{{name}}') && 
                                    <Box className={`${whatsappPreviewStyles.whatsappPreview__locationHeaderField} ${whatsappPreviewStyles["whatsappPreview__locationHeaderField--name"]}`}>
                                        <Typography className={whatsappPreviewStyles.whatsappPreview__locationHeaderNameText}>
                                            {getLocationFieldValue(findLocationHeaderField(locationHeaderFields(), '{{name}}'))}
                                        </Typography>
                                    </Box>
                                }
                                {findLocationHeaderField(locationHeaderFields(), '{{address}}') && 
                                    <Box className={whatsappPreviewStyles.whatsappPreview__locationHeaderField}>
                                        <Typography className={whatsappPreviewStyles.whatsappPreview__locationHeaderAddressText}>
                                            {getLocationFieldValue(findLocationHeaderField(locationHeaderFields(), '{{address}}'))}
                                        </Typography>
                                    </Box>
                                }
                            </Box>
                        }
                    </Box>
                </>
            default:
                return <></>;
        }
    }

    return (
        <>
            {renderHeaderMediaComponent()}
        </>
    )
}

export default TemplateHeaderPreview
